const pickBy = (obj: any, fn: Function) =>
    Object.keys(obj)
        .filter((k) => fn(obj[k], k))
        .reduce((acc, key) => ((acc[key] = obj[key]), acc), {} as any);
export {pickBy}
